module.exports = __webpack_public_path__ + "static/media/wireframe.8663fa3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductPlanningTesting/assets/wireframe.png
// module id = 508
// module chunks = 0